import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Sparkles, Baby, Users, GraduationCap, Settings } from 'lucide-react';

const HomePage = () => {
  const navigate = useNavigate();

  const roles = [
    {
      id: 'child',
      label: 'I\'m a Child',
      icon: Baby,
      color: 'from-pink-400 to-rose-400',
      description: 'Play games and learn!',
      route: '/child-setup'
    },
    {
      id: 'parent',
      label: 'I\'m a Parent',
      icon: Users,
      color: 'from-blue-400 to-cyan-400',
      description: 'Monitor your child\'s progress',
      route: '/parent-setup'
    },
    {
      id: 'teacher',
      label: 'I\'m a Teacher',
      icon: GraduationCap,
      color: 'from-green-400 to-emerald-400',
      description: 'Track your students\' learning',
      route: '/teacher-setup'
    }
  ];

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 md:p-8" style={{
      background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)'
    }}>
      <div className="max-w-6xl w-full flex-1 flex flex-col justify-center">
        <div className="text-center mb-12 bounce-in">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <Sparkles className="w-24 h-24 text-yellow-300 float-animation" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-16 h-16 bg-white rounded-full opacity-20"></div>
              </div>
            </div>
          </div>
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-4" style={{
            textShadow: '4px 4px 8px rgba(0,0,0,0.3)'
          }}>
            Little Genius Hub
          </h1>
          <p className="text-2xl md:text-3xl text-white opacity-90">Where Young Minds Grow!</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {roles.map((role, index) => {
            const IconComponent = role.icon;
            return (
              <Card
                key={role.id}
                className="cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-2xl overflow-hidden slide-up"
                style={{
                  animationDelay: `${index * 0.1}s`,
                  borderRadius: '28px'
                }}
                onClick={() => navigate(role.route)}
              >
                <div className={`h-48 bg-gradient-to-br ${role.color} flex items-center justify-center relative overflow-hidden`}>
                  <div className="absolute inset-0 opacity-20">
                    <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-16 -translate-y-16"></div>
                    <div className="absolute bottom-0 right-0 w-24 h-24 bg-white rounded-full translate-x-12 translate-y-12"></div>
                  </div>
                  <IconComponent className="w-24 h-24 text-white float-animation" />
                </div>
                <div className="p-6 bg-white">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2">{role.label}</h3>
                  <p className="text-gray-600 mb-4">{role.description}</p>
                  <div
                    className="w-full py-5 text-lg font-bold text-center text-white transition-all duration-300 rounded-2xl"
                    style={{
                      background: `linear-gradient(135deg, ${role.color.replace('from-', '').replace(' to-', ', ')})`
                    }}
                  >
                    Continue as {role.label.replace("I'm a ", "")}
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </div>

      {/* Admin Panel Button */}
      <div className="mt-8 pb-4">
        <button
          onClick={() => navigate('/admin')}
          className="flex items-center gap-2 px-4 py-2 text-white/60 hover:text-white hover:bg-white/10 rounded-lg transition-all duration-300"
        >
          <Settings className="w-4 h-4" />
          <span className="text-sm">Admin Panel</span>
        </button>
      </div>
    </div>
  );
};

export default HomePage;
